// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import UsercustomerService from "../Masters/Usercustomers/UsercustomerService.js";
// import SettingsServices from "../Settings/SettingsServices.js";
// import Credentials, { currentTenant, transactionFrom, userid } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import directtradeIcon from "../images/Icons/agreement.png"
// import posIcon from "../images/Icons/pos-terminal.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css"; // Import the shared CSS file

// const PurchaseMenu = () => {
//   const [hovered, setHovered] = useState(null);
//   const [usercustomers, setUsercustomers] = useState(false);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Purchase")
//     UsercustomerService.GetUserCustomersbyUser(userid).then((res) => setUsercustomers(res.data === '' || res.data === undefined || res.data === null ? false : true))
//   }, [])

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>
      
//       <Header />
//       <Menu />
      
//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <nav className="menu-breadcrumb">
//                 <Link
//                   to="/index"
//                   className="menu-breadcrumb-link"
//                   onMouseEnter={() => setHovered('home')}
//                   onMouseLeave={() => setHovered(null)}
//                 >
//                   Home
//                 </Link>
//                 <span>/</span>
//                 <span className="menu-breadcrumb-active">
//                   Purchase
//                 </span>
//               </nav>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                   {screens.includes("Direct Trade") ? (
//                     <li className="menu-nav-item">
//                       <Link
//                         to={{ pathname: "/directtrade" }}
//                         state={{ message: "" }}
//                         className="menu-nav-link"
//                       >
//                         <img className="menu-nav-icon" width="25" src={directtradeIcon} />
//                         <div className="mt-1">Direct Trade</div>
//                       </Link>
//                     </li>
//                   ) : ""}
//                 </ul>
                
//                 <div className="menu-sections-container">
//                   {(screens.includes("Purchase") || screens.includes("Purchase Returns") || screens.includes("GRN") || screens.includes("SCN") || screens.includes("Bill of Entry") || screens.includes("Credit Note")) ? (
//                     <div className="menu-section menu-transactions-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                         <span className="menu-section-title-text">Transactions</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         {screens.includes("Purchase") || screens.includes("Purchase Order") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/purchaseorder" }}
//                               state={{ message: "" }}
//                             >
//                               Purchase Order
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("GRN") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/grn" }}
//                               state={{ message: "" }}
//                             >
//                               GRN
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("SCN") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/scn" }}
//                               state={{ message: "" }}
//                             >
//                               SCN
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Purchase Returns") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/purchasereturns" }}
//                               state={{ message: "" }}
//                             >
//                               Purchase Returns
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Bill of Entry") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/billofentry" }}
//                               state={{ message: "" }}
//                             >
//                               Bill of Entry
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Credit Note") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/debitnotes" }}
//                               state={{ message: "" }}
//                             >
//                               Debit Note
//                             </Link>
//                           </li>
//                         ) : ""}
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {screens.includes("Purchase Reports") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-reports" src={reportsIcon} />
//                         <span className="menu-section-title-text">Reports</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/purchasereport" }}
//                             state={{ message: "" }}
//                           >
//                             Purchase Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/purchasereturnsreport" }}
//                             state={{ message: "" }}
//                           >
//                             Purchase Returns Report
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/purchaseagentsreports" }}
//                             state={{ message: "" }}
//                           >
//                             Agents Report
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(PurchaseMenu);







import React from 'react';
import { 
  FolderLock, 
  ArrowRightLeft, 
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  ShoppingCart,
  CheckCircle2,
  Coins
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const PurchaseMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
     {
      title: 'Transactions',
      subtitle: 'Supplier procurement ledger operations',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'po', label: 'Purchase Order', desc: 'Authorized supplier buy agreements', icon: ShoppingCart, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/purchaseorder', brandColor: theme === 'classic'? '#4d4d4d' : '#3B82F6' },
        { id: 'grn', label: 'Goods Received Note (GRN)', desc: 'Warehouse inventory entry signatures', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 tw-text-teal-700', path: '/grn', brandColor: theme === 'classic'? '#4d4d4d' : '#14B8A6' },
        { id: 'scn', label: 'Service Completion Note (SCN)', desc: 'Approved supplier receipt acknowledgements', icon: CheckCircle2, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/scn', brandColor: theme === 'classic'? '#4d4d4d' : '#10B981' },
        { id: 'pur_ret', label: 'Purchase Returns', desc: 'Outward defective stock returns logs', icon: ArrowRightLeft, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700', path: '/purchasereturns', brandColor: theme === 'classic'? '#4d4d4d' : '#F43F5E' },
        { id: 'boe', label: 'Bill Of Entry', desc: 'Customs clearance declarations logs', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/billofentry', brandColor: theme === 'classic'? '#4d4d4d' : '#F59E0B' },
        { id: 'deb_note', label: 'Debit Note', desc: 'Claims adjustments against supplier invoices', icon: Coins, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-707', path: '/debitnotes', brandColor: theme === 'classic'? '#4d4d4d' : '#6366F1' }
      ]
    },
    {
      title: 'Reports',
      subtitle: 'Expense & logistics indexes',
      icon: FileText,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'rpt_pur', label: 'Purchase Report', desc: 'Chronological summary of buy bills', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/purchasereport', brandColor: theme === 'classic'? '#4d4d4d' : '#10B981' },
        { id: 'rpt_pur_ret', label: 'Purchase Returns Report', desc: 'Procurement return volume breakdown', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/purchasereturnsreport', brandColor: theme === 'classic'? '#4d4d4d' : '#10B981' },
        { id: 'rpt_pur_agent', label: 'Agents Report', desc: 'Procurement broker rates payout matrices', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/purchaseagentsreports', brandColor: theme === 'classic'? '#4d4d4d' : '#10B981' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
        <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

         <Layout menu={"purchase"}>
         <div className="menu-container tw-mr-2 tw-ml-4">
          <div
  id="dashboard-content-area"
  className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
>
  {/* Upper Hero Grid */}
  <div
    id="hero-welcome-banner"
    className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
  >
    {/* Background Blur Shapes */}
    <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

    {/* Left Content */}
    <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
      <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Purchase & Procurement",path:null}]}/>
      <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
        Purchase &amp; Procurement
      </h1>

      <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
      Track authorized outgoing purchase orders, verify received materials with Goods Received Notes, outline customs clearances, and track supplier debit notes.
      </p>
    </div>

     {/* 3D SVG Security Badging Illustration */}
        <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
          {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
          <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center">

            <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>
            
              <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
              <defs>
                <linearGradient id="truckBody" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#3B82F6" />
                  <stop offset="100%" stopColor="#1D4ED8" />
                </linearGradient>
                <linearGradient id="cargoBox" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#10B981" />
                  <stop offset="100%" stopColor="#047857" />
                </linearGradient>
              </defs>
              {/* Ground shadow */}
              <ellipse cx="100" cy="155" rx="70" ry="10" fill="#1E293B" opacity="0.3" />
              {/* Cargo Truck Outline */}
              {/* Back Container Cargo */}
              <rect x="35" y="60" width="90" height="70" rx="8" fill="url(#cargoBox)" />
              {/* Front Cabin */}
              <path d="M125 75 L155 90 L155 130 L125 130 Z" fill="url(#truckBody)" />
              {/* Cabin Windshield */}
              <path d="M125 78 L146 88 L142 105 L125 105 Z" fill="#E2E8F0" opacity="0.8" />
              {/* Wheels */}
              <circle cx="55" cy="142" r="16" fill="#1E293B" />
              <circle cx="55" cy="142" r="6" fill="#94A3B8" />
              <circle cx="105" cy="142" r="16" fill="#1E293B" />
              <circle cx="105" cy="142" r="6" fill="#94A3B8" />
              <circle cx="140" cy="142" r="16" fill="#1E293B" />
              <circle cx="140" cy="142" r="6" fill="#94A3B8" />
              {/* Box Logistics graphic */}
              <path d="M60 80 L80 95 L100 80" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" opacity="0.9" />
            </svg>
          </div>
        </div>
  </div>

  {/* Main Grid */}
  <div
    id="erp-columns-grid"
    className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
  >


    {/* Menus */}
        {newsections.map((section) => {
          // const Icon = section.icon;
          return(
     <div
            key={section.title}
      id="section-col-masters"
      className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
    >
      <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
        <div
          className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
        >
          <FolderLock size={22} />
          {/* <Icon size={22} color={section.iconColor} /> */}
        </div>

        <div>
          <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
            {section.title}
          </h2>

          <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
            {section.subtitle}
          </p>
        </div>
      </div>

      <div className="tw-space-y-3 tw-flex-1">
        {section.items.map((item) => {
          const Icon = item.icon;

          return (
            <button
              id={`subsection-btn-${item.id}`}
              key={item.id}
              onClick={() => onSelectItem(item.path)}
              className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
            >
              <div className="tw-flex tw-items-center tw-gap-3.5">
                <div
                  className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                >
                  <Icon size={16} color={item.brandColor} />
                </div>

                <div>
                  <h4 className={`tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors`}>
                    {item.label}
                  </h4>

                  {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                </div>
              </div>

              <ChevronRight
                size={16}
                className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
              />
            </button>
          );
        })}
      </div>
    </div>)}
  )}
  </div>

</div>
          </div>
          </Layout>
      </div>
  );
}
export default withRouter(PurchaseMenu);